import React from "react";
import LoginForm from "./common/LoginForm";
import { connect } from "react-redux";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import {
  DetailsList,
  Spinner,
  SpinnerSize,
  DatePicker,
  MessageBar,
  MessageBarType,
  CheckboxVisibility,
} from "office-ui-fabric-react";
import axios from "axios";
import { browserHistory } from "react-router";

import imgCity from "./imgs/city.jpg";
import imgLogo from "./imgs/login-logo.png";
import request from "axios";
import StatusBar from "./common/StatusBar";
import config from "../config";
import _ from "lodash";
import moment from "moment";
import { Label } from "react-bootstrap";
export class StaffReporing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      error: false,
      data: [],
      startDate: null,
      endDate: null,
    };
  }
  componentDidMount() {
    this.loadData();
  }

  loadData() {
    this.setState({
      isLoading: true,
    });
    axios
      .get(config.apiUrl + "/customer/cu-report", {
        params: {
          start: this.state.startDate,
          end: this.state.endDate,
        },
      })
      .then(({ data }) => {
        this.setState({
          data: data,
          isLoading: false,
          error: false,
        });
      })
      .catch((ex) => {
        this.setState({
          isLoading: false,
          error: true,
        });
      });
  }

  changeDate(key, date) {
    this.setState({
      [key]: date,
    });

    setTimeout(() => {
      this.loadData();
    }, 500);
  }

  render() {
    const { data, isLoading, error, startDate, endDate } = this.state;
    const { isDisplayChart, isDisplayTable } = this.props;
    if (error) {
      return (
        <div>
          <MessageBar messageBarType={MessageBarType.error}>
            Load error
          </MessageBar>
        </div>
      );
    }
    return (
      <div>
        <div className="ms-Grid" style={{ marginTop: 10 }}>
          <div className="ms-Grid-col ms-u-md5"></div>
          <div className="ms-Grid-col ms-u-md3">
            <DatePicker
              label="Start Date"
              className="one-line-100"
              formatDate={(date) => moment(date).format("MMM DD YYYY")}
              value={startDate ? new Date(startDate) : null}
              onSelectDate={(date) => this.changeDate("startDate", date)}
              allowTextInput
            />
          </div>
          <div className="ms-Grid-col ms-u-md1"></div>
          <div className="ms-Grid-col ms-u-md3">
            <DatePicker
              label="End Date"
              className="one-line-100"
              formatDate={(date) => moment(date).format("MMM DD YYYY")}
              value={endDate ? new Date(endDate) : null}
              onSelectDate={(date) => this.changeDate("endDate", date)}
              allowTextInput
            />
          </div>
        </div>
        {isLoading ? (
          <Spinner size={SpinnerSize.large} />
        ) : (
          <div style={{ display: "flex", flexFlow: "wrap" }}>
            <div
              style={{
                width: "20%",
                margin: 20,
                padding: 20,
                boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.2)",
              }}
            >
              <span>Leads sent to Closers:</span>{" "}
              <div style={{ fontSize: 20, fontWeight: "bold" }}>
                {data.totalWithCloser || 0}
              </div>
            </div>
            <div
              style={{
                width: "20%",
                margin: 20,
                padding: 20,
                boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.2)",
              }}
            >
              <span>Leads have not sent to Closers:</span>{" "}
              <div style={{ fontSize: 20, fontWeight: "bold" }}>
                {data.totalWithoutCloser || 0}
              </div>
            </div>

            <div
              style={{
                width: "20%",
                margin: 20,
                padding: 20,
                boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.2)",
              }}
            >
              <span>Have no Assignment:</span>{" "}
              <div style={{ fontSize: 20, fontWeight: "bold" }}>
                {data.totalWithoutAssignment || 0}
              </div>
            </div>
            <div
              style={{
                width: "20%",
                margin: 20,
                padding: 20,
                boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.2)",
              }}
            >
              <span>Home Health:</span>{" "}
              <div style={{ fontSize: 20, fontWeight: "bold" }}>
                {data.totalHomeHealth || 0}
              </div>
            </div>
            <div
              style={{
                width: "20%",
                margin: 20,
                padding: 20,
                boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.2)",
              }}
            >
              <span>Hospice:</span>{" "}
              <div style={{ fontSize: 20, fontWeight: "bold" }}>
                {data.totalHospice || 0}
              </div>
            </div>

            <div
              style={{
                width: "20%",
                margin: 20,
                padding: 20,
                boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.2)",
              }}
            >
              <span>Clinic:</span>{" "}
              <div style={{ fontSize: 20, fontWeight: "bold" }}>
                {data.totalClinic || 0}
              </div>
            </div>

            <div
              style={{
                width: "20%",
                margin: 20,
                padding: 20,
                boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.2)",
              }}
            >
              <span>SignUp:</span>{" "}
              <div style={{ fontSize: 20, fontWeight: "bold" }}>
                {data.totalSignUp || 0}
              </div>
            </div>

            <div
              style={{
                width: "20%",
                margin: 20,
                padding: 20,
                boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.2)",
              }}
            >
              <span>Remind:</span>{" "}
              <div style={{ fontSize: 20, fontWeight: "bold" }}>
                {data.totalHavingReminder || 0}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect((state) => ({
  auth: state.auth,
}))(StaffReporing);



// WEBPACK FOOTER //
// ./client/components/CUReporting.js